import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axios";


export const fetchRoles = createAsyncThunk(
    'role/fetchRoles',
    async(_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('v1/accounts/role/');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
); 

export const createRole = createAsyncThunk(
    'role/createRole',
    async(data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('v1/accounts/role/', data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
); 

export const deleteRole = createAsyncThunk(
    'role/deleteRole',
    async(id, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`v1/accounts/role/${id}/`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
); 

export const fetchRole = createAsyncThunk(
    'role/fetchRole',
    async(id, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`v1/accounts/role/${id}/`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
); 

export const updateRole = createAsyncThunk(
    'role/updateRole',
    async(data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.patch(`v1/accounts/role/${data.id}/`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
); 


const roleSlice = createSlice({
    name: 'role',
    initialState: {
        roles: [],
        role: null,
        roleLoading: false,
        roleError: null,
        roleSuccess: false
    },
    reducers: {
        clearRole: (state) => {
            state.roleLoading = false;
            state.roleError = null;
            state.roleSuccess = false;
            state.role = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchRoles.pending, (state) => {
                state.roleLoading = true;
                state.roleError = null;
            })
            .addCase(fetchRoles.fulfilled, (state, action) => {
                state.roleLoading = false;
                state.roles = action.payload;
            })
            .addCase(fetchRoles.rejected, (state, action) => {
                state.roleLoading = false;
                state.roleError = action.payload?.message || "Cannot fetch roles";
            })
            .addCase(createRole.pending, (state) => {
                state.roleLoading = true;
                state.roleError = null;
                state.roleSuccess = false;
            })
            .addCase(createRole.fulfilled, (state, action) => {
                state.roleLoading = false;
                state.roleSuccess = true;
            })
            .addCase(createRole.rejected, (state, action) => {
                state.roleLoading = false;
                state.roleError = Array.isArray(action.payload?.role) && action.payload.role.length > 0
                ? action.payload.role[0]
                : "Cannot create role";

            })
            .addCase(deleteRole.pending, (state) => {
                state.roleLoading = true;
                state.roleError = null;
                state.roleSuccess = false;
            })
            .addCase(deleteRole.fulfilled, (state, action) => {
                state.roleLoading = false;
                state.roleSuccess = true;
                const deletionId = action.meta.arg;
                state.roles = state.roles.filter(role => role.id !== deletionId);
            })
            .addCase(deleteRole.rejected, (state, action) => {
                state.roleLoading = false;
                state.roleError = Array.isArray(action.payload?.role) && action.payload.role.length > 0
                ? action.payload.role[0]
                : "Cannot delete role";

            })
            .addCase(fetchRole.pending, (state) => {
                state.roleLoading = true;
                state.roleError = null;
            })
            .addCase(fetchRole.fulfilled, (state, action) => {
                state.roleLoading = false;
                state.role = action.payload;
            })
            .addCase(fetchRole.rejected, (state, action) => {
                state.roleLoading = false;
                state.roleError = action.payload?.message || "Cannot fetch role";
            })
            .addCase(updateRole.pending, (state) => {
                state.roleLoading = true;
                state.roleError = null;
                state.roleSuccess = false;
            })
            .addCase(updateRole.fulfilled, (state, action) => {
                state.roleLoading = false;
                state.roleSuccess = true;
            })
            .addCase(updateRole.rejected, (state, action) => {
                state.roleLoading = false;
                state.roleError = Array.isArray(action.payload?.role) && action.payload.role.length > 0
                ? action.payload.role[0]
                : "Cannot update role";              
            })
    }
});

export const { clearRole } = roleSlice.actions;
export default roleSlice;